import React from 'react'
import Navbar from './Navbar'

const Ecosystem = () => {
  return (
    <>
    <Navbar/>
    <div>
      Ecosystem Page Comming Soon....
    </div>
    </>
  )
}

export default Ecosystem
